import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  add as addBoard,
} from '../redux/boards'

export default function * fetchBoardTile (action) {
  const { boardId } = action.payload

  try {
    const Board = yield call(apiGetData, 'BoardTile', {
      id: boardId
    })

    yield put(addBoard({
      id: Board.Id,
      name: Board.Name,
      background: Board.Background,
      isObserved: Board.IsObserved,
      hasAccess: true,
      isClosed: Board.IsClosed,
      isTemplate: Board.IsTemplate,
      isPublic: Board.IsPublic,
      isLocked: Board.IsLocked,
      permissionLevel: Board.PermissionLevel,
    }))
  } catch (error) {
    if (
      error.code === 401 ||
      error.code === 601
    ) {
      yield put(addBoard({
        id: boardId,
        name: '',
        color: null,
        isObserved: false,
        hasAccess: false,
        isClosed: false,
        isTemplate: false,
        isPublic: false,
        permissionLevel: 0
      }))
    }
  }
}
